var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',{staticClass:"editor",class:{
    verticalPane:
      this.$store.state.isVertical && this.$store.state.showInOutBox,
    editorFull: !this.$store.state.showInOutBox,
  },attrs:{"id":_vm.editorId}})}
var staticRenderFns = []

export { render, staticRenderFns }